
<div>
  <div class="modal-header">
    <h3>Add {{ meta.verbose_name }} </h3>
  </div>
  <ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r[meta.autocomplete.field]" [term]="t"></ngb-highlight>
</ng-template>
  <fieldset class="form-inline">
  <div class="modal-body">
     <div class="form-group">
      <input id="input-auto"
        type="text"
        class="form-control has-feedback has-clear"
        placeholder="Search for {{ meta.verbose_name }}"
       [(ngModel)]="item" [ngbTypeahead]="searchData" [class.is-invalid]="searchFailed" [resultTemplate]="rt"
             [inputFormatter]="formatter"
      />
       <small *ngIf="searching" class="form-text text-muted">searching...</small>
       <small *ngIf="noMatch && !searching" class="text-danger">No match found.</small>
    <div class="invalid-feedback" *ngIf="searchFailed">Sorry, suggestions could not be loaded.</div>
     </div>
  </div>
  </fieldset>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="ok()">Add</button>
    <button class="btn btn-warning" (click)="activeModal.dismiss()">Cancel</button>
  </div>
</div>
